import React from 'react';
import { AlertTriangle, AlertOctagon } from 'lucide-react';

const STYLES = {
  danger: { cls: 'bg-red-100 text-red-700 border-red-200', Icon: AlertOctagon },
  warning: { cls: 'bg-orange-100 text-orange-700 border-orange-200', Icon: AlertTriangle },
};

export const CompanyStatusBadge = ({ status, compact = false, className = '' }) => {
  if (!status || !STYLES[status.level]) return null;
  const { cls, Icon } = STYLES[status.level];
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-xs font-semibold ${cls} ${className}`}
      title={status.text || status.label}
      data-testid={`company-status-badge-${status.level}`}
    >
      <Icon className="w-3.5 h-3.5 flex-shrink-0" />
      {compact ? status.label : (status.text || status.label)}
    </span>
  );
};

export default CompanyStatusBadge;
